module.exports = __webpack_public_path__ + "img/qywxadd.a624da91.png";